import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ab7001b46b6be0202504fda37ed3f7711b from "./generated-91b19bb3-0d83-48ef-aefa-9f1a3470fa24.json";

import a70a257e9d6f875b6b67c3c92800d0dc6b from "./generated-1af47301-8707-4263-839e-9d9f89d7a6d4.json";

import ab5ad79f0d274185d3a033e5bc3ddc688b from "./generated-7c5e27b2-f4c4-4f6f-8e09-4d536bd560f6.json";

import aae71f75e665df0ce9871406e118da2d2b from "./generated-87210767-58b5-493f-88fc-9d9fa830d82e.json";

import a0f03e35b056d89a55cd35d8c854acc8eb from "./generated-27d770c4-29e4-4647-8d3c-8097bb2d4f3d.json";

import a400111b41e77e78d55ff1220b4b08fa0b from "./generated-5c8c6df3-c4b9-48da-93cc-250602c12ed6.json";

import a9611ab165fd396fb8674921a95bd3a18b from "./generated-b492e7bf-1f6c-4bfe-8619-a7611ffc2c23.json";

import a688f89de9d0a802e4c53f0f47dc5f408b from "./generated-cea66c32-339f-4b00-8dd8-d4c63b9437d9.json";

import af202245088352b8cb4d40fc9d8863c60b from "./generated-8ad9f95a-e088-4ebf-9823-fbf4f9258690.json";

import ad7d1e12e3b82a42a01e840afadccad11b from "./generated-c9235205-8ae7-4306-bf90-cbdc2434e20b.json";

import aabbd56403ad3648e9ee35a0beb9a1621b from "./generated-9e28a8c5-074d-4fd7-8a2b-3d5e495f8899.json";

import a3e9d959d8517a26ae919bd40819e395fb from "./generated-b0afe187-1ef9-42aa-98df-3bdd1631880f.json";

import a33b043835829f8f4dbb7d98f2815c655b from "./generated-17e78324-b17f-4acf-81b1-c3ca625fe9bb.json";

import a5c7f2df78caa3ae201d806e8d90b35f2b from "./generated-127d6443-de11-44b4-9665-a95c7d6ba44c.json";

import a3dd37d77acafe376e239b37ebcccfdd4b from "./generated-b1df830f-2252-4c77-ab6d-c254f8909eb9.json";

import ad002ef5a63ebb353e90f3aaf83d12107b from "./generated-7155499e-f8be-46ce-a7a3-ee50b44ecd10.json";

import ae4827add256ad7d2ad99f6e35b2069fab from "./generated-58a3e16c-9155-4dd1-bc4f-aba3f935a70d.json";

import ae43833e24e62a04d53752bddf5c6b309b from "./generated-45dfb518-6a90-409d-91e8-6fc8f101d4ba.json";

import a1a371fff343632d260d6e50a1c8d63fcb from "./generated-500399c3-291b-46fb-acbf-f0d9893f919a.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ab7001b46b6be0202504fda37ed3f7711b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a70a257e9d6f875b6b67c3c92800d0dc6b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ab5ad79f0d274185d3a033e5bc3ddc688b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aae71f75e665df0ce9871406e118da2d2b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a0f03e35b056d89a55cd35d8c854acc8eb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a400111b41e77e78d55ff1220b4b08fa0b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a9611ab165fd396fb8674921a95bd3a18b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a688f89de9d0a802e4c53f0f47dc5f408b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(af202245088352b8cb4d40fc9d8863c60b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ad7d1e12e3b82a42a01e840afadccad11b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aabbd56403ad3648e9ee35a0beb9a1621b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a3e9d959d8517a26ae919bd40819e395fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a33b043835829f8f4dbb7d98f2815c655b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a5c7f2df78caa3ae201d806e8d90b35f2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a3dd37d77acafe376e239b37ebcccfdd4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ad002ef5a63ebb353e90f3aaf83d12107b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ae4827add256ad7d2ad99f6e35b2069fab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae43833e24e62a04d53752bddf5c6b309b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a1a371fff343632d260d6e50a1c8d63fcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ae4827add256ad7d2ad99f6e35b2069fab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */